export function createNamedRouter(routerFactory, routes, opts) {
    const router = routerFactory(routes, opts);
    const { urlToRoute, routeNameToUrl } = createRouteMap(routes);
    router.urlFromNamedRoute = function (route) {
        return routeNameToUrl[route.routeName];
    };
    router.routeFromUrl = function (url) {
        return urlToRoute[url];
    };
    router.getResolvedRoute = function (route) {
        if (!route.index) {
            return route.route;
        }
        else {
            return route.indexForRoute;
        }
    };
    return router;
}
function createRouteMap(routes) {
    const pairs = createRoutePairs(routes);
    const urlToRoute = Object.fromEntries(pairs);
    const routeNameToUrl = Object.fromEntries(pairs.map(([url, route]) => {
        return [route.routeName, url];
    }));
    return { urlToRoute, routeNameToUrl };
}
function createRoutePairs(routes, parentPath, parentRoute) {
    let fixedParentPath = parentPath;
    if (fixedParentPath && !fixedParentPath.endsWith("/")) {
        fixedParentPath += "/";
    }
    return routes.flatMap((route) => {
        if (route.index) {
            if (route.path) {
                console.log("WARNING: only one of path or index is allowed, ignoring route");
            }
            if ((parentRoute === null || parentRoute === void 0 ? void 0 : parentRoute.index) || route.indexForRoute.routeName !== (parentRoute === null || parentRoute === void 0 ? void 0 : parentRoute.route.routeName)) {
                console.log(`WARNING: indexForRoute must reference direct parent route: ${route.indexForRoute.routeName}`);
            }
            return [];
        }
        else {
            const resolvedPath = (fixedParentPath !== null && fixedParentPath !== void 0 ? fixedParentPath : "") + route.path;
            const childRoutes = route.children ? createRoutePairs(route.children, resolvedPath, route) : [];
            return [[resolvedPath, route.route], ...childRoutes];
        }
    });
}
